<script lang="ts">
  import { defineComponent } from 'vue';
  import {
    OrderListPreselect,
    OrdersDelayedNotificationType,
  } from '@/helpers/types';
  import { RouteNames, StoreMutations } from '@/helpers/enums';

  export default defineComponent({
    props: {
      data: {
        type: Object as () => OrdersDelayedNotificationType,
        required: true,
      },
    },
    emits: {
      close: () => true,
    },
    methods: {
      onNotificationClicked(): void {
        this.$emit('close');
        this.$store.commit(StoreMutations.setOrderListPreselect, {
          prioritised: true,
        } as OrderListPreselect);

        this.$router.push({ name: RouteNames.orders });
      },
    },
  });
</script>

<template>
  <div @click="onNotificationClicked">
    <h4 class="fw-semibold">{{ data.body }}</h4>
    <hr class="dashed mt-16 mb-24" />
    <div class="d-flex flex-grow-1 justify-content-center">
      <p class="link fw-bold">{{ $t('actions.go_to_orders') }}</p>
    </div>
  </div>
</template>
